import { Link } from "react-router-dom";
import classes from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={classes.footer}>
      <div className={classes.content}>
                <div/>
        <div className={classes.brand}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <h2>dothink</h2>
          <div className={classes.social}>
          <a
            href="https://www.instagram.com/hamesjan/"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 10C13 10.5933 12.8241 11.1734 12.4944 11.6667C12.1648 12.1601 11.6962 12.5446 11.1481 12.7716C10.5999 12.9987 9.99667 13.0581 9.41473 12.9424C8.83279 12.8266 8.29824 12.5409 7.87868 12.1213C7.45912 11.7018 7.1734 11.1672 7.05764 10.5853C6.94189 10.0033 7.0013 9.40013 7.22836 8.85195C7.45542 8.30377 7.83994 7.83524 8.33329 7.50559C8.82664 7.17595 9.40666 7 10 7C10.7949 7.00247 11.5565 7.31934 12.1186 7.88141C12.6807 8.44349 12.9975 9.20511 13 10Z"
                fill="#1E1E1E"
              />
            </svg>
          </a>
        </div>
            </div>
          <p className={classes.version}>v1.0</p>
        </div>

        {/* Middle: Links */}
        <div className={classes.links}>
          <Link to="/info">About</Link>
          <Link to="/contact">Contact Us</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy Policy</Link>
        </div>
        <div/>
      </div>
    </footer>
  );
};

export default Footer;
